import React from 'react';

export const FetchApiContext = React.createContext({
  fetchApi: () => {},
});
